import { render, staticRenderFns } from "./Unauthorized.vue.js?vue&type=template&id=04c4d332!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Unauthorized.vue?vue&type=template&id=04c4d332"
import script from "./Unauthorized.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Unauthorized.vue?vue&type=script&lang=js"
import style0 from "./Unauthorized.vue.scss?vue&type=style&index=0&id=04c4d332&prod&lang=scss!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Unauthorized.vue?vue&type=style&index=0&id=04c4d332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports